/* eslint-disable @typescript-eslint/naming-convention */
export enum AppRoutes {
  ACCOUNT_PROFILE = '/account/profile',
  CHECKOUT = '/checkout',
  CONCESSIONS = '/concessions',
  HOME = '/',
  MOVIE_REWARDS = '/movie-rewards',
  SHOPPING_CART = '/shopping-cart',
  TICKET_SEAT_MAP = '/ticket-seat-map',
}
